module.exports = {
    en: {
        contact: {
            title: "Fill Form",
            firstp: 'One step closer to your new car! Just complete the short form and our sales manager will contact you shortly.',
            inputtitle1: "Full name",
            plcholder1: "Enter your full name",
            inputtitle2: "Phone number",
            plcholder2: "Enter your phone number",
            submit: "Submit Form",
        }

    },
    ka: {
        contact: {
            title: "შეავსეთ ფორმა",
            firstp: 'ერთი ნაბიჯით მიუახლოვდით თქვენს ახალ მანქანას! უბრალოდ შეავსეთ მოკლე ფორმა და ჩვენი გაყიდვების მენეჯერი მალე დაგიკავშირდებათ.',
            inputtitle1: "სახელი და გვარი",
            plcholder1: "შეიყვანეთ თქვენი სახელი და გვარი",
            inputtitle2: "ტელეფონის ნომერი",
            plcholder2: "შეიყვანეთ თქვენი ტელეფონის ნომერი",
            submit: "ფორმის გაგზავნა",
        }
    },
    ru: {
        contact: {
            title: "Заполнить форму",
            firstp: 'На шаг ближе к вашему новому автомобилю! Просто заполните короткую форму, и наш менеджер по продажам свяжется с вами в ближайшее время.',
            inputtitle1: "Полное имя",
            plcholder1: "Введите свое полное имя",
            inputtitle2: "Номер телефона",
            plcholder2: "Введите свой номер телефона",
            submit: "Отправить форму",
        }
    }
}